"use client";

import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { RFQDigestTab } from "./components/RFQDigestTab";
import { CustomAnnouncementsTab } from "./components/CustomAnnouncementsTab";
import { HistoryTab } from "./components/HistoryTab";
import { Mail, Megaphone, History } from "lucide-react";

export default function AdminMassCommunicationsPage() {
  const [activeTab, setActiveTab] = useState("rfq-digest");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Mass Communications</h1>
        <p className="text-muted-foreground mt-2">
          Manage bulk email communications to vendors
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full max-w-[500px] grid-cols-3">
          <TabsTrigger value="rfq-digest" className="flex items-center gap-2">
            <Mail className="h-4 w-4" />
            RFQ Digest
          </TabsTrigger>
          <TabsTrigger value="announcements" className="flex items-center gap-2">
            <Megaphone className="h-4 w-4" />
            Announcements
          </TabsTrigger>
          <TabsTrigger value="history" className="flex items-center gap-2">
            <History className="h-4 w-4" />
            History
          </TabsTrigger>
        </TabsList>

        <TabsContent value="rfq-digest" className="space-y-6">
          <RFQDigestTab />
        </TabsContent>

        <TabsContent value="announcements" className="space-y-6">
          <CustomAnnouncementsTab />
        </TabsContent>

        <TabsContent value="history" className="space-y-6">
          <HistoryTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
